import { Chart, BarElement, BarController, LinearScale, CategoryScale, Tooltip } from 'chart.js'

Chart.register(BarElement, BarController, LinearScale, CategoryScale, Tooltip )

export default Chart